import { render, staticRenderFns } from "./EhrLoginPage.vue?vue&type=template&id=a0a05448"
import script from "./EhrLoginPage.vue?vue&type=script&lang=js"
export * from "./EhrLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports